import {
  OrderPaymentsService,
  OrderPaymentTransactionCreate,
  OrderPaymentTransactionResponse,
  OrderPaymentTransactionUpdate,
} from "@/api";

export const PaymentTransactionService = {
  async list(
    orderId: number
  ): Promise<OrderPaymentTransactionResponse[]> {
    return OrderPaymentsService
      .listPaymentTransactionsOrderPaymentsTransactionsOrderIdGet(
        orderId
      );
  },

  async get(
    transactionId: number
  ): Promise<OrderPaymentTransactionResponse> {
    return OrderPaymentsService
      .getPaymentTransactionOrderPaymentsIdGet(
        transactionId
      );
  },

  async update(
    transactionId: number,
    payload: OrderPaymentTransactionUpdate
  ): Promise<OrderPaymentTransactionResponse> {
    return OrderPaymentsService
      .updatePaymentTransactionOrderPaymentsIdPut(
        transactionId,
        payload
      );
  },

  async create(
    payload: OrderPaymentTransactionCreate
  ): Promise<OrderPaymentTransactionResponse> {
    return OrderPaymentsService
      .createPaymentTransactionOrderPaymentsPost(
        payload
      );
  },
};